/** A date-only value is a calendar day, never a UTC instant. */
export function localCalendarDate(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}
export function formatCalendarDate(value: string | null | undefined): string {
  if (!value) return "—";
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
}
export function isCalendarDatePast(
  value: string | null | undefined,
  now = new Date(),
): boolean {
  return !!value && value < localCalendarDate(now);
}
